import { render, staticRenderFns } from "./UnknownSearch.vue?vue&type=template&id=025a7ee1&scoped=true&"
import script from "./UnknownSearch.vue?vue&type=script&lang=js&"
export * from "./UnknownSearch.vue?vue&type=script&lang=js&"
import style0 from "./UnknownSearch.vue?vue&type=style&index=0&id=025a7ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a7ee1",
  null
  
)

/* custom blocks */
import block0 from "./UnknownSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports